import '../NavBar.css';

import React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
  FaCog,
  FaSignInAlt,
  FaSignOutAlt,
  FaUser,
  FaUserPlus,
} from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const ProfileDropdown = React.forwardRef((props, ref) => {
  const { handleNavigation, handleLogout } = props;
  const location = useLocation();

  const userInfo = useSelector((state) => state.user);
  const isLoggedIn = !!(userInfo && userInfo.isAuthenticated && userInfo.user);

  const isActiveTab = (path) => {
    if (path === "/" && location.pathname === "/") {
      return true;
    }
    if (path !== "/" && location.pathname.startsWith(path)) {
      return true;
    }
    return false;
  };

  const loggedInItems = [
    { icon: <FaUser />, label: "View Profile", path: "/profile/me" },
    { icon: <FaCog />, label: "Account Settings", path: "/account" },
  ];

  const loggedOutItems = [
    { icon: <FaSignInAlt />, label: "Login", path: "/login" },
    { icon: <FaUserPlus />, label: "Sign Up", path: "/register" },
  ];

  const renderMenuItem = (item) => (
    <ListItem
      button
      key={item.path}
      onClick={(event) => {
        event.stopPropagation();
        handleNavigation(item.path, event);
      }}
      className={`navbar-v2-menu-item${isActiveTab(item.path) ? " navbar-v2-menu-item--active" : ""}`}
    >
      <ListItemIcon className="navbar-v2-menu-icon">{item.icon}</ListItemIcon>
      <ListItemText primary={item.label} />
    </ListItem>
  );

  return (
    <div ref={ref} className="navbar-v2-menu navbar-v2-menu--dropdown">
      <List className="navbar-v2-menu-list" disablePadding>
        {(isLoggedIn ? loggedInItems : loggedOutItems).map(renderMenuItem)}
      </List>
      {isLoggedIn && (
        <>
          <div className="navbar-v2-menu-divider" />
          <List className="navbar-v2-menu-list" disablePadding>
            <ListItem
              button
              onClick={(event) => {
                event.stopPropagation();
                handleLogout(event);
              }}
              className="navbar-v2-menu-item navbar-v2-menu-item--logout"
            >
              <ListItemIcon className="navbar-v2-menu-icon">
                <FaSignOutAlt />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </>
      )}
    </div>
  );
});

export default ProfileDropdown;
